function slugify(text) {
  if (text && text !== '') {
    // remove accents, swap ñ for n, etc
    const from = 'åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;'
    const to = 'aaaaaaeeeeiiiioooouuuunc------'

    let data = text
    data = data.replace(/^\s+|\s+$/g, '').toLowerCase()

    for (let i = 0, l = from.length; i < l; i += 1) {
      data = data.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
    }

    data = data
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-') // collapse dashes

    return data
  }
  return ""
}

export { slugify }


// WEBPACK FOOTER //
// ./src/node_modules/components/Pimper/utils/slugify.js